import React, { useState, useEffect } from "react";
import PageHead from "components/page-head";
import styled from "styled-components";
import { Formik } from "formik";
import { Level1Form } from "../form";
import { maxQuery } from "utils/responsivenessHelper";
import { useParams } from "@reach/router";
import api from "api";
import validationSchema from "../form/validation-schema";
import user from "containers/user";
import actionContext from "../../shared/forms/action-context";

const EditContainer = styled.div`
  width: 100%;
`;

const ActionContextContainer = styled.div`
  display: none;
  ${maxQuery.both({ display: "flex" }, "850px")}

  button {
    width: 17em;
    margin: 0 auto;
  }
`;

const INITIAL_VALUES = {
  // details
  title: "",
  description: "",
  id: "",
  startDate: null,
  endDate: null,
  verifiedAt: null,

  // skills developed
  skillNames: [],

  // organisation
  organisationId: "",
  organisationName: "",
  organisationWebsite: "",
  primaryContactName: "",
  primaryContactEmail: "",
  noResultInd: false,
  requestVerificationInd: false,
  isLoading: true,
};

const Edit = () => {
  const [initialValues, setInitialValues] = useState(INITIAL_VALUES);
  const { credentialId } = { ...useParams() };
  const [editable, setEditable] = useState(false);

  useEffect(() => {
    getWorkExperience();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const inputs = document.querySelectorAll("input, textarea");
    inputs.forEach((input) => (input.disabled = !editable));
  }, [editable]);

  async function getWorkExperience() {
    const response = await api.users.credentials.getById(
      user.state.id,
      credentialId
    );
    const { job, startDate, endDate } = { ...response.data };
    setInitialValues({
      ...job,
      startDate: new Date(startDate) || null,
      endDate: new Date(endDate) || null,
      skillNames: job.skills,
      isLoading: false,
    });

    // When the time comes, will check if verified. If verified, editable is false
    if (true) {
      setEditable(false);
    }
  }

  async function onSubmit(values, actions) {}

  const loaded = !initialValues.isLoading;
  return (
    <EditContainer>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {({ handleSubmit, ...rest }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <PageHead
              title={
                loaded ? `${editable ? "Edit" : "View"} work experience` : ""
              }
              actionContext={loaded && editable ? actionContext(rest) : null}
            />
            <Level1Form editable={editable} />
            <ActionContextContainer>
              {loaded && editable ? actionContext(rest) : null}
            </ActionContextContainer>
          </form>
        )}
      </Formik>
    </EditContainer>
  );
};
export default Edit;
